<template>
    <div class="mask">
        <div class="bottom-stage">
            <img src="../assets/threatMask/bottom-stage.png">
        </div>
        <div class="option-box option-route">
            <img src="../assets/threatMask/option-route.png">
        </div>
        <div class="option-box option-domain">
            <img src="../assets/threatMask/option-domain.png">
        </div>
        <div class="option-box option-certificate">
            <img src="../assets/threatMask/option-certificate.png">
        </div>
        <div class="option-box option-website">
            <img src="../assets/threatMask/option-website.png">
        </div>
        <div class="option-box option-mail">
            <img src="../assets/threatMask/option-mail.png">
        </div>

      <div class="name">
         <!--    路由    -->
        <div class="bgpName">
          <div v-for="item in bgp" :class="item.display == 'false' ? 'disable':'nameBtn'">
            <el-tooltip class="item" effect="dark" :content="item.name" placement="top-start" :open-delay="1000">
              <span v-if="item.display == 'false'">{{item.name}}</span>
              <span v-if="item.display == 'yes'" @click="getThreatVul(item.id)">{{item.name}}</span>
            </el-tooltip>
          </div>
        </div>
          <!-- 域名-->
        <div class="dnsName">
          <div v-for="item in dns" :class="item.display == 'false' ? 'disable':'nameBtn'">
            <el-tooltip class="item" effect="dark" :content="item.name" placement="top-start" :open-delay="1000">
              <span v-if="item.display == 'false'">{{item.name}}</span>
              <span v-if="item.display == 'yes'" @click="getThreatVul(item.id)">{{item.name}}</span>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
import {getNewThreats} from "@/service/dashboard";
import { mapMutations} from "vuex";

export default {
  data(){
    return {
      all:[],  //总览
      dns:[],  //域名
      bgp:[],  //路由
      pki:[],  //证书
      email:[], //邮件
      web:[]  //网站
    };
  },
  created() {
    this.getVulInfo();
  },
  methods: {
    ...mapMutations("dict", ["setThreatId"]),
    getVulInfo() {
      getNewThreats().then(res => {
        this.dns = res.dns.inf;
        this.bgp = res.bgp.inf;
        console.log( this.dns, this.bgp);
      });
    },
    getThreatVul(id) {
      this.setThreatId(id);
      this.$emit("showThreatInfo");
    }
  }
};
</script>
<style lang="less" scoped>
.right {
  text-align: center;
}
.mask {
    position: fixed;
    width: 100%;
    height: 100%;
    top:0;
    left:0;
    background: #000000B2;
    z-index: 9;
    .bottom-stage {
        width:607px;
        height: 338px;
        position:absolute;
        left:657px;
        top: 568px;
        img {
            width: 100%;
            height: 100%;
        }
    }
    .option-box {
        position: absolute;
        width: 105px;
        height: 149px;
        img {
            width: 100%;
            height: 100%;
        }
    }
    .option-route {
        left:596px;
        top:617px;
    }
    .option-domain {
        left:710px;
        top: 450px;
    }
    .option-certificate {
        left:908px;
        top: 373px;
    }
    .option-website {
        left:1107px;
        top: 450px;
    }
    .option-mail {
        left:1220px;
        top: 617px;
    }


  .name{
    position: relative;
    width: 100%;
    height: 100%;
    top:0;
    left:0;
    user-select: none;
    cursor: pointer;
    //background: rgba(185, 63, 63, 0.7);
    z-index: 9;
    .nameBtn{
      width: 92px;
      height: 50px;
      color: #fff;
      background: linear-gradient(to right, rgba(75, 90, 201, 1),rgba(113, 125, 219, 0.4));
      border-radius: 8px;
      margin: 4px;
      display: flex;
      justify-content: center;
      align-items: center;
      span{
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2; /* 定义文本的行数 */
        overflow: hidden;
        text-overflow: ellipsis;
        width: 100%;
        font-size: 14px;
        font-family: AlibabaRegular;
      }
    }
    .disable{
      width: 92px;
      height: 50px;
      color: #fff;
      background: linear-gradient(to right, rgba(108, 111, 157, 1),rgba(73, 74, 98, 0.4));
      border-radius: 8px;
      margin: 4px;
      display: flex;
      justify-content: center;
      align-items: center;

      span{
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2; /* 定义文本的行数 */
        overflow: hidden;
        text-overflow: ellipsis;
        width: 100%;
        font-size: 14px;
        font-family: AlibabaRegular;
      }
    }
    .bgpName{
      height: 225px;
      width: 400px;
      //background-color: #00F0FF;
      display: flex;
      flex-wrap: wrap;
      position: absolute;
      top: 54%;
      left: 8%;
    }
    .dnsName{
      height: 170px;
      width: 400px;
      //background-color: #00F0FF;
      display: flex;
      flex-wrap: wrap;
      position: absolute;
      top: 34%;
      left: 16%;
    }
  }
}
</style>
